import {
  Typography,
  Box,
  Card,
  Grid,
  CardContent,
  Button,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';

import {Avatar} from '@jobseeker/lotus/components';
import {Image} from '@jobseeker/lotus/components/Image';
import {useDispatch, useSelector} from 'react-redux';
import {handleTracking, openUrl} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {
  fetchJobDetails,
  fetchJobInsights,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobdetail';
import ScheduledInterview from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/internalComponents/ScheduledInterview';
import {
  AppliedTileProps,
  RECRUITER_ACTION_TEXT,
} from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/types';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';

import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import userService from '@jobseeker/common-core/services/user.service';
import {useEffect, useState} from 'react';
import LockedStatus from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/internalComponents/LockedStatus';
import {BottomsheetNoTtitle} from '@jobseeker/lotus/elements';
import {JobdetailQr} from '@jobseeker/lotus/assets/images/index';
import {border, borderRadius} from '@mui/system';
import {LineChart, UserDP} from '@jobseeker/lotus/assets/icons';

const TooltipHirist = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  ul: {
    margin: 0,
    padding: '14px 15px',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#1c2d41',
    color: '#fff',
    fontSize: 16,
    // border: '1px solid #dadde9',
  },
  '.MuiTooltip-arrow:before': {
    backgroundColor: '#1c2d41',
  },
}));

const AppliedMobTileV2 = ({
  id,
  applicantId,
  applicationId,
  applicationDate,
  recruiterDetail,
  recruiterAction,
  jobDetail,
  followUp,
  views,
  app_count,
  unpublishInfo,
  confidential,
  app_status,
  recruiterActions,
  inviteStatus,
  lastActive,
  isPro,
  hasfollowup,
  interviewDate,
  interviewTime,
  calId,
  slotId,
  remSlots,

  setshowProMembershipPrompt,
  setShowFollowUpProMembershipPrompt,
  setInsightsbox,
  setShowStatusProMembershipPrompt,
}: AppliedTileProps) => {
  lastActive = lastActive || {
    lastActiveDate: new Date().toISOString(),
  };
  const loc = jobDetail.location.map(obj => {
    return obj.name;
  });
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  // useValidateAuth(dispatch);
  function removeHtmlAndAppendRef(url: string) {
    // Remove ".html" at the end if present
    const cleanedUrl = url.endsWith('.html') ? url.slice(0, -5) : url;

    // Check if the URL already contains a query string
    if (cleanedUrl.includes('?')) {
      return `${cleanedUrl}&ref=apj`;
    }

    // If no query string is present, append `?ref=akf`
    return `${cleanedUrl}?ref=apj`;
  }

  const jobUrl = removeHtmlAndAppendRef(jobDetail.jobUrl);

  const formatPostedTime = (createdTime: string | number): string => {
    const jobTime = new Date(createdTime);
    const formattedDate = `${jobTime.getDate()}-${
      jobTime.getMonth() + 1
    }-${jobTime.getFullYear()}`;
    return `Posted on: ${formattedDate}`;
  };
  const [followedUp, setFollowedUp] = useState(followUp.status);
  const [followUpBottom, setFollowUpBottom] = useState(false);
  const router = useRouter();

  const handleJobFollowup = () => {
    if (!isPro) {
      setShowFollowUpProMembershipPrompt(true);
    } else {
      if (!hasfollowup) {
        setFollowUpBottom(true);
      } else {
        handleTracking('ClickFollowUp', {
          event_category: 'Job',
          Origin: router.pathname,
          Source: 'JobDescription',
          CategoryId: jobDetail.categoryId,
          JobId: jobDetail.id,
          RecruiterId: recruiterDetail?.recruiterId,
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
        });

        (async () => {
          try {
            const followUp = await jobDetailService.doFollowUp({
              jobId: jobDetail.id,
            });
            if (typeof followUp === 'boolean') {
              // await userService.updateFollowUp();
              setFollowedUp(followUp);
            }
          } catch (error: unknown) {
            console.log('🚀 ~ file: index.tsx:298 ~ error:', error);
          }
        })();
      }
    }
  };
  const initiateChat = () => {
    if (!(window as any).chatObject) return;

    (window as any).chatObject.initiateChat({
      type: 'j', // r- recruiter, j- jobseeker
      userId: applicantId,
      recipientId: recruiterDetail.recruiterId,
      tokenName: `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_CK1`,
    });
  };
  const jd: JB = useSelector((state: any) => state.jobDetail);

  useEffect(() => {
    if (jd && jd.id === jobDetail.id) {
      console.log('jobDetails', jd);
      setInsightsbox(true);
    }
  }, [jd, jobDetail.id]);

  const openInsightsDialog = async () => {
    if (!isPro) {
      setshowProMembershipPrompt(true);
    } else {
      try {
        await dispatch(fetchJobDetails({jobId: String(jobDetail.id)}));
        await dispatch(
          fetchJobInsights({
            userId: String(applicantId),
            jobId: String(jobDetail.id),
          })
        );

        handleTracking('prostatusview', {
          event_category: 'insightpopup',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: router.pathname,
          Type: 'view',
          CompanyId: recruiterDetail.organisationId,
        });
      } catch (error) {
        console.error('Error fetching job insights:', error);
      }
    }
  };
  return (
    <>
      <BottomsheetNoTtitle
        maxHeight={170}
        open={followUpBottom}
        onDismiss={() => {
          setFollowUpBottom(false);
        }}
      >
        <Box p={3} pt={0}>
          <Typography variant="body2" fontSize={16} fontWeight={500}>
            Oops!! You don't have any more follow ups left.{' '}
          </Typography>

          <Button
            sx={{
              width: {lg: '125px'},
              background: '#000',
              mt: {xxs: 1, md: 2},
              px: 2,
              py: 1,
              height: 'fit-content',
              backgroundColor: 'secondary.main',
              borderRadius: 8,
            }}
            variant="contained"
            size="large"
            onClick={() => {
              setFollowUpBottom(false);
            }}
          >
            Okay
          </Button>
        </Box>
      </BottomsheetNoTtitle>
      <Card
        data-testid="applied-mobile-card"
        sx={{
          margin: 0,
          boxShadow: 0,
          p: 2,
          ml: 2,
          mb: 2,
          width: 'calc(100% - 32px)',
          borderRadius: 2,
        }}
      >
        {unpublishInfo &&
        unpublishInfo?.unpublishedDate &&
        unpublishInfo?.unpublishedDate > 1 ? (
          <>
            <Typography
              data-testid="applied-mobile-unpublish-info"
              variant="body2"
              sx={{
                cursor: 'default',
                marginTop: 0,
                paddingTop: 0,
                fontSize: 14,
                fontWeight: 300,
                fontStyle: 'normal',
                color: 'red !important',
              }}
            >
              This job was unpublished on{' '}
              {String(
                new Date(unpublishInfo.unpublishedDate).getDate()
              ).padStart(2, '0')}
              -
              {String(
                new Date(unpublishInfo.unpublishedDate).getMonth() + 1
              ).padStart(2, '0')}
              -{new Date(unpublishInfo.unpublishedDate).getFullYear()}
              <br></br>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 300,
                  fontStyle: 'normal',
                  color: '#797979',
                }}
              >
                {' '}
                Reason: {unpublishInfo.unpublishReason}
              </Typography>
            </Typography>
            <Box
              sx={{
                width: 'calc(100% + 32px)',
                ml: -2,
                height: '1px',
                backgroundColor: 'var(--dividers, rgba(126, 126, 126, 0.2))',
                my: 1,
              }}
            />
          </>
        ) : (
          <></>
        )}
        <Box display={'flex'}>
          <Image
            data-testid="applied-mobile-job-icon"
            src={UserDP}
            alt="dp"
            width={12}
            height={12}
            style={{marginTop: '4px', marginRight: '8px'}}
          />
          <Typography
            data-testid="applied-mobile-job-title"
            variant="body2"
            component="a"
            href={jobUrl}
            sx={{
              cursor: 'pointer',
              userSelect: 'none',
              color: '#000',
              textDecoration: 'none',

              width: 'calc(100% - 8px)',
              paddingTop: 0,
              paddingBottom: 0,
              marginBottom: 0,

              fontSize: 14,
              fontWeight: 600,
              fontStyle: 'normal',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',

              whiteSpace: 'normal',
            }}
            onClick={event => {
              event.preventDefault(); // Prevent default anchor behavior
              openUrl(jobUrl, '_blank', 'noopener,noreferrer');
            }}
          >
            {`${jobDetail.title.replace(/\(.*?\)/g, '').trim()}`}
          </Typography>
        </Box>

        <Typography
          data-testid="applied-mobile-application-date"
          variant="body2"
          sx={{
            marginTop: 0.25,
            paddingTop: 0,
            fontSize: 12,
            ml: '19px',

            fontWeight: 300,
            fontStyle: 'normal',
            color: '#000',
            opacity: 0.7,
          }}
        >
          {new Date(applicationDate)
            .toLocaleDateString('en-GB')
            .split('/')
            .join('-')}
          &nbsp;&nbsp; <span style={{color: '#cecece'}}>&#9679;</span>
          &nbsp;&nbsp;
          {RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT'
            ? 'Applied/Sent'
            : RECRUITER_ACTION_TEXT[app_status].charAt(0).toUpperCase() +
              RECRUITER_ACTION_TEXT[app_status].slice(1).toLowerCase()}
        </Typography>
        <Box
          sx={{
            width: 'calc(100% + 32px)',
            ml: -2,
            height: '1px',
            backgroundColor: 'var(--dividers, rgba(126, 126, 126, 0.2))',
            my: 1,
          }}
        />

        <Grid container direction="row" mt={1.5} mb={inviteStatus ? 0 : 0.5}>
          <Grid item mb={0} width={'50px'} mr="15px">
            <Avatar
              data-testid="applied-mobile-recruiter-avatar"
              onClick={
                confidential
                  ? () => {}
                  : () => {
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              sx={{
                cursor: confidential ? 'default' : 'pointer',
                height: 50,
                width: 50,
                borderRadius: '10px',
                border: '1px solid #ececec',
              }}
              imgUrl={confidential ? '' : recruiterDetail.pictureLink}
            />
          </Grid>
          <Grid item ml={0.5} mt={0} xxs={9} mb={0}>
            <Typography
              data-testid="applied-mobile-recruiter-name"
              sx={{
                mt: 0,
                pt: 0,
                userSelect: 'none',
                fontSize: 16,
                fontWeight: 600,
                color: '#0057ff',

                fontStyle: 'normal',
                cursor: confidential ? 'default' : 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'none',
                },
              }}
              onClick={
                confidential
                  ? () => {}
                  : event => {
                      event.preventDefault();
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              color="primary"
            >
              {confidential ? 'Verified Recruiter' : recruiterDetail.name}
            </Typography>

            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingBottom: 0,
                  marginBottom: 0,

                  fontSize: 14,
                  fontWeight: 600,
                  fontStyle: 'normal',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',

                  whiteSpace: 'normal',
                }}
              >
                {`${recruiterDetail.designation} at ${recruiterDetail.organisationName}`}
              </Typography>
            )}
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  fontSize: 14,
                  visibility: lastActive ? 'visible' : 'hidden',

                  fontWeight: 200,
                  fontStyle: 'normal',
                }}
              >
                Last Active:{' '}
                {lastActive && lastActive?.lastActiveDate
                  ? !isNaN(new Date(lastActive.lastActiveDate).getTime())
                    ? new Date(lastActive.lastActiveDate).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          timeZone: 'UTC',
                        }
                      )
                    : lastActive.lastActiveDate
                  : ''}
              </Typography>
            )}
          </Grid>
        </Grid>

        <CardContent
          data-testid="applied-mobile-stats"
          sx={{
            padding: 0,
            mt: 1.5,
            mb: 1.5,

            backgroundColor: '#f2f5fa',
            width: 'calc(100% - 8px)',
            height: 80,
            borderRadius: '5px',
          }}
        >
          <Grid container direction="row">
            <Grid
              item
              xxs={4}
              mt={1}
              px={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRight: '1px solid #fff',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  fontStyle: 'normal',
                  height: '38px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Views
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 16,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                  opacity: 0.8,
                }}
              >
                {views?.toString()}
              </Typography>
            </Grid>
            <Grid
              item
              xxs={4}
              px={2}
              mt={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRight: '1px solid #fff',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  fontStyle: 'normal',
                  height: '38px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Applications
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 16,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                  opacity: 0.8,
                }}
              >
                {app_count?.toString()}
              </Typography>
            </Grid>

            <Grid
              item
              mt={1}
              px={2}
              xxs={4}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  fontStyle: 'normal',
                  wordBreak: 'break-word',
                  textAlign: 'center',
                  height: '38px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Recruiter Actions
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 16,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                  opacity: 0.8,
                }}
              >
                {recruiterActions?.toString()}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>

        <Box
          display="flex"
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Box display="flex" flexDirection="column" mt={1}>
            <Button
              data-testid="applied-mobile-insights-btn"
              onClick={openInsightsDialog}
              variant="text"
              color="primary"
              sx={{
                justifyContent: 'flex-start',
                textTransform: 'none',
                padding: 0,
                fontSize: 15,
                border: 'none',
                boxShadow: 'none',
                whiteSpace: 'nowrap',
                fontWeight: 400,
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none',
                },
                '&:focus': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
                '&:active': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
              }}
            >
              <Box display={'flex'}>
                <Image
                  src={LineChart}
                  alt="lc"
                  width={20}
                  height={20}
                  style={{marginRight: '4px'}}
                ></Image>{' '}
                View Detailed Insights
              </Box>
            </Button>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                marginTop: 0.25,
                justifyContent: 'flex-start',
                ml: 3,

                fontSize: 14,
                whiteSpace: 'nowrap',
                fontWeight: 200,
              }}
            >
              {formatPostedTime(jobDetail.createdTime)}
            </Typography>
          </Box>
          {isPro && !hasfollowup && app_status <= 0 ? (
            <TooltipHirist
              data-testid="applied-mobile-followup-tooltip"
              arrow
              title="Oops!! You don't have any more follow ups left."
              disableInteractive
            >
              <span>
                <Button
                  data-testid="applied-mobile-followup-btn"
                  disabled={
                    followedUp ||
                    (isPro && !hasfollowup) ||
                    (app_status > 0 && isPro == true)
                  }
                  onClick={handleJobFollowup}
                  variant="outlined"
                  color="primary"
                  sx={{
                    borderRadius: '4px',
                    width: followedUp ? 110 : 91,
                    backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                    fontSize: 16,
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    padding: '9px 13px',
                    color: followedUp ? '#e9630c' : '#fff',
                    minWidth: 'auto',
                    boxShadow: 3,
                    height: 32,
                    '&:hover': {
                      backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                      textDecoration: 'none',
                    },
                    '&:focus': {
                      backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                    },
                    '&:active': {
                      backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                    },
                  }}
                >
                  <Typography
                    sx={{
                      mt: -0.5,
                      color: followedUp ? '#e9630c' : '#fff',
                      fontSize: 14,
                      fontWeight: 400,
                    }}
                  >
                    {followedUp ? 'Followed Up' : 'Follow Up'}
                  </Typography>
                </Button>
              </span>
            </TooltipHirist>
          ) : (
            <Button
              data-testid="applied-mobile-followup-btn-simple"
              disabled={
                followedUp ||
                (isPro && !hasfollowup) ||
                (app_status > 0 && isPro == true)
              }
              onClick={handleJobFollowup}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: '4px',
                width: followedUp ? 110 : 91,
                display: app_status <= 0 ? 'inline' : 'none',
                backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                fontSize: 16,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                padding: '9px 13px',
                color: followedUp ? '#e9630c' : '#fff',

                minWidth: 'auto',
                boxShadow: 3,
                height: 32,
                '&:hover': {
                  backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                  textDecoration: 'none',
                },
                '&:focus': {
                  backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                },
                '&:active': {
                  backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                },
              }}
            >
              <Typography
                sx={{
                  mt: -0.5,
                  color: followedUp ? '#e9630c' : '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                }}
              >
                {followedUp ? 'Followed Up' : 'Follow Up'}
              </Typography>
            </Button>
          )}
        </Box>
      </Card>
    </>
  );
};

export default AppliedMobTileV2;
